import { canv } from "@/canv/global";
import RedoSvg from "@/icons/Redo.svg?react";
import UndoSvg from "@/icons/Undo.svg?react";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";
import { HStack } from "@/shared/ui/Stack";
import styles from "./BottomLeftBar.module.scss";

export const BottomLeftBar = () => {
    const actionSymbol = canv.actionManager.actionSymbol;

    return (
        <div className={styles.bottomLeftBar}>
            {!canv.isBoardModeView() && (
                <HStack gap={2} className={styles.toolBoxArrows}>
                    <Tooltip content="Отменить" hotkey={`${actionSymbol} + Z`} placement="right">
                        <BottomBarItem onClick={canv.eventManager.Undo.bind(canv.eventManager)}>
                            <UndoSvg />
                        </BottomBarItem>
                    </Tooltip>
                    <Tooltip
                        content={`Повторить`}
                        hotkey={`${actionSymbol} + Shift + Z`}
                        placement="right"
                    >
                        <BottomBarItem onClick={canv.eventManager.Redo.bind(canv.eventManager)}>
                            <RedoSvg />
                        </BottomBarItem>
                    </Tooltip>
                </HStack>
            )}
        </div>
    );
};
